export const FIXED_TABLE_COLUMNS = {
  // CHECKBOX: 'checkbox',
  NAME: 'name',
  EMAIL: 'email',
};

export const DYNAMIC_TABLE_COLUMNS = { NDA: 'nda' };

export const FIXED_COLUMN_TRANSLATIONS = {
  [FIXED_TABLE_COLUMNS.NAME]: 'name',
  [FIXED_TABLE_COLUMNS.EMAIL]: 'email',
};

export const FIXED_COLUMN_SIZE = {
  // [FIXED_TABLE_COLUMNS.CHECKBOX]: 50,
  [FIXED_TABLE_COLUMNS.NAME]: 200,
  [FIXED_TABLE_COLUMNS.EMAIL]: 200,
};

export const DYNAMIC_COLUMN_SIZE = 200;
